import React, { FC, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { CardActionArea } from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import SnackBarAlert from "../../components/Alerts/AlertComponent";
import * as Validations from "../../helpers/validations";

import { addToCart, resetMessage } from '../../flux/actions/shoppingCart-actions';
import { listProductDetails } from '../../flux/actions/product-actions';

import "../../styles/Products/ButonStyle.scss";

import soldOut from '../../assets/sold_out.png';
import { NotFoundSearch } from "../../views/NotFoundSearch";

const useStyles = makeStyles({
  root: {
    "& > *": {
      margin: "8px",
      width: "25ch",
    },
  },
  root1: {
    maxWidth: 400,
    left: 16,
    top: 97,
    height: 400,
  },
  root2: {
    maxWidth: 400,
    left: 16,
    top: 97,
    height: 400,
  },

  media: {
    height: 400,
    paddingTop: "56.25%",
    width: "100%",
    backgroundsize: "auto",
  },
  soldOut: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
  }
});

const ProductCardDesktop: FC = () => {
  const [count, setCount] = useState(1);
  const [isProductInCart, setIsProductInCart] = useState(false);
  
  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();
  const cart = useSelector((state: any) => state.cart);
  const { isProductAdded, cartItems } = cart;
  const productDetails = useSelector((state: any) => state.productReducer);
  const { product = {} } = productDetails;

  const buyProductHandler = (id: string) => {
    history.push(`/cart/${id}?qty=${count}`);
  }

  const addToCartHandler = (id: string) => {
    let productInCart = cartItems.some((item:any) => item.id === id);
    if (!productInCart) {
      dispatch(addToCart(id, count));
    } else {
      setIsProductInCart(true);
    }
  }

  const amountHandler = (e : any) => {
    if (Validations.formatInteger(e.target.value)) {
      setCount(e.target.value);
    } else {
      setCount(1);
    }

    if (e.target.value >= product.amount) {
      setCount(product.amount);
    }
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setIsProductInCart(false);
  };

  return (
    <div>
      {isProductAdded && <SnackBarAlert severity='success' message='Se ha agregado un producto al carrito' open={isProductAdded}/>}
      {isProductInCart && <SnackBarAlert severity='info' message='Este producto ya fue agregado, modifica la cantidad en tu carrito!' open={isProductInCart} onClose={handleClose}/>}
      { product.isDelete ? <NotFoundSearch/> :
        <Grid
          alignItems="center"
          direction="row"
          justify="center"
          spacing={1}
          container
          item
          lg={12}
        >
          <Grid item lg={4} sm={4}>
            <Card className={classes.root1}>
              <CardActionArea>
                <CardMedia
                  className={classes.media}
                  image={product.image}
                  title={product.full_name}
                />
                {((product.amount === 0 || !product.status) || !product.categoryRef.isActive) && 
                <img className={classes.soldOut} src={soldOut} alt="Sold Out"/>}
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item lg={4}>
            <Card className={classes.root2}>
              <CardActionArea></CardActionArea>
              <CardContent>
                <Typography variant="h4" display="block" component="h2">
                  {product.full_name}
                </Typography>
                <div style={{ width: "100%" }}>
                  <Box display="flex" p={1} bgcolor="background.paper">
                    <Box p={1}>
                      <Typography color="textSecondary">Precio</Typography>
                      <Typography display="block" color="secondary">
                        ${product.cost ? product.cost.toFixed(2) : ''}
                      </Typography>
                      <br />
                    </Box>
                    {(product.amount > 0 && product.status && product.categoryRef.isActive) && 
                      <Box p={1} ml={8} className={classes.root}>
                          <button
                            onClick={() => setCount(count <= 1 ? 1 : count - 1)}
                            className="buttonStyleAdd "
                          >
                            -
                          </button>
                          <input
                            className="quantityStyle"
                            type="text"
                            value={count}
                            onChange={amountHandler}
                          />
                          <button
                            onClick={() => setCount(count >= product.amount ? product.amount : count + 1)}
                            className="buttonStyleAdd"
                          >
                            +
                          </button>
                      </Box>
                    }
                  </Box>
                </div>
                
                <Typography variant="body2" component="p">
                  {product.description}
                </Typography><br />
                {
                    product.amount === count &&
                    <Typography variant="subtitle2" component="p" align="center">
                      La compra esta limitada a {product.amount} unidades del producto
                    </Typography>
                  }
              </CardContent>
              {(product.amount > 0 && product.status && product.categoryRef.isActive) && 
                <CardActions>
                  <div style={{ width: "100%" }}>
                    <Box p={1} display="flex">
                      <Box flexGrow={1}>
                        <Button 
                          className="buttonY"
                          onClick={() => buyProductHandler(product._id)}
                        >
                          Comprar
                        </Button>
                      </Box>
                      <Box flexGrow={1}>
                        <Button
                          className="buttonY"
                          variant="contained"
                          color="secondary"
                          onClick={() => addToCartHandler(product._id)}
                        >
                          Añadir
                        </Button>
                      </Box>
                    </Box>
                  </div>
                </CardActions>
              }
            </Card>
          </Grid>
        </Grid>
      }
    </div>
  );
};

export default ProductCardDesktop;
